/**
 * Company: SPHMedia
 * Description: [Brief description of the component]
 */

import QuoteSVG from "@assets/icons/quote.svg?react";
import type { BFFArticleCard } from "@src/app/types/bff";
import clsx from "clsx";
import type { ReactElement } from "react";

import Link from "../Link";
import OptimisedImage from "../OptimisedImage/OptimisedImage";

type OpinionCardProps = {
  // Define the type for the props required by the component (if any)
  article: BFFArticleCard;
  className?: string;
  testId?: number | string;
};

/**
 * OpinionCard
 * Description: [Description of what the component does]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function OpinionCard({
  article,
  className = "",
  testId,
}: OpinionCardProps): ReactElement {
  // Add component logic and state here

  return (
    <div
      data-testid={`opinion-card-${testId}`}
      className={clsx("group relative inline-block px-3 py-4", className)}
    >
      <div className="group relative">
        <Link to={article.urlPath}>
          <div className="relative">
            <OptimisedImage
              rootClassName="aspect-square lg:group-hover:scale-105 transition-transform duration-300 object-cover"
              src={article.cover}
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-transparent to-black/60" />
          </div>
          <div className="pointer-events-auto absolute left-1/2 top-1/2 flex w-full -translate-x-1/2 -translate-y-1/2 flex-col gap-[12px] px-[32px]">
            <QuoteSVG fill="white" />
            <h2 className="line-clamp-3 text-header-2 text-primary-on-dark lg:hover:underline lg:group-hover:underline">
              {article.title}
            </h2>
            <h3 className="text-subheader text-primary-on-dark">
              {article.authors[0]?.name}
            </h3>
          </div>
        </Link>
      </div>
    </div>
  );
}
